module.exports = __webpack_public_path__ + "static/img/icon_service_foreign_serve.4993a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_service_foreign_serve.png
// module id = Ae1k
// module chunks = 1